import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import './TafInput.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { ErrorBanner } from '../ErrorBanner/ErrorBanner';

const propTypes = {
  input: PropTypes.instanceOf(Object),
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
  }),
  label: PropTypes.node,
  hidden: PropTypes.bool,
  isMandatory: PropTypes.bool,
  disabled: PropTypes.bool,
  colorBlack: PropTypes.bool,
  isYear: PropTypes.bool,
  icons: PropTypes.instanceOf(Object),
  customIcons: PropTypes.node,
  isLongLabel: PropTypes.bool,
  isMiddleLabel: PropTypes.bool,
  isLabel: PropTypes.bool,
  isCurrency: PropTypes.bool,
};

export const TafInput = (props) => {
  const {
    input,
    meta: {
      error,
      touched,
    },
    label,
    hidden,
    isMandatory,
    disabled,
    isYear,
    colorBlack,
    icons,
    customIcons,
    isLongLabel,
    isMiddleLabel,
    isLabel,
    isCurrency,
    ...restCustom
  } = props;

  return (
    <div
      className={
          cx('taf-input-row', { hidden, error: touched && error })
        }
    >
      <div className={
            cx(isLabel ? 'taf-input-row--label inputField' : 'taf-input-row--label', {
              colorBlack,
              'taf-input-row--label-large': isLongLabel,
              'taf-input-row--label-middle': isMiddleLabel,
            })
          }
      >
        { label &&
        <span
          className={
                cx({ 'taf-input-row--label-notMandatory': !isMandatory })
              }
          title={label}
        >
          {label}
        </span>}
        {
            isMandatory && <span className="isMandatorySign">*</span>
          }
      </div>
      <div className={
          cx('taf-input-row--input-container', { 'taf-input-row--input-container-year': isYear },
            { 'fas fa-euro-sign': isCurrency },
            { 'error-class': touched && error })
          }
      >
        <input
          className="taf-input"
          {...input}
          {...restCustom}
          disabled={disabled}
        />
      </div>
      {touched && error && <ErrorBanner
        title={error}
      />}
      {icons &&
        <div className="taf-input-row--icons-container">
          {icons.copy &&
          <div
            title={icons.copyTitle || ''}
            role="presentation"
            onClick={icons.copyCb}
            className="taf-icon taf-icon-layers"
          />}
          {icons.view &&
          <div
            title={icons.viewTitle || ''}
            role="presentation"
            onClick={icons.viewCb}
            className="taf-icon taf-icon-details"
          />}
        </div>}
      {
          customIcons &&
          <div className="taf-input-row--custom-icons-container">
            {customIcons}
          </div>
        }
    </div>
  );
};
TafInput.propTypes = propTypes;
TafInput.defaultProps = {
  meta: {},
};
